import React, { Component } from 'react'

class SendNotice extends Component {
    render() {
        return (
            <div style={{ padding: "10px" }}>

                <form className="was-validated">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                {/* <div className="card-header bg-primary" style={{ color: "white" }}>Send Motice</div> */}
                                <div className="card-body">
                                    
                                    <div className="row">
                                        <div className="form-group col-lg-12">
                                            <label for="fname"><b>To</b></label>
                                            <select class="form-control">
                                                <option>All</option>
                                                <option>All Teacher</option>
                                                <option>All Parents</option>
                                                <option>Std 1 Parents</option>
                                                <option>Std 2 Parents</option>
                                                <option>Std 3 Parents</option>
                                                <option>Std 4 Parents</option>
                                                <option>Deepak</option>
                                                <option>Rahul</option>
                                                <option>Sandeep</option>
                                                <option>Ashutosh</option>
                                            </select>
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-12">
                                            <label for="fname"><b>Notice Header</b></label>
                                            <input type="text" class="form-control" id="uname"
                                                name="fname" placeholder="Notice Header" required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                       
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-12">
                                            <label for="fname"><b>Notice Message</b></label>
                                            <textarea class="form-control">

                                            </textarea>
                                            {/* <input type="text" class="form-control" id="uname" placeholder="Enter Location"
                                                name="fname" placeholder="Notice Message" required /> */}
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>

                                    </div>

                                    {/* <div class="row">
                                        <div class="col-lg-12 " style={{ textAlign: "end" }}>
                                            <button type="submit" class="btn btn-primary">Submit</button>
                                            <button type="reset" class="btn btn-success">Reset</button>
                                            <button class="btn btn-primary">Back</button>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        );
    }
}

export default SendNotice;